import { Box } from "@components/Box/Box";
import { Container } from "@components/Container/Container";
import { Icon } from "@components/Icon/Icon";
import { Link } from "@components/Link/Link";
import { Text } from "@components/Text/Text";
import React from "react";
import styles from "./styles.module.scss";
import facebookIcon from "@svg-icons/facebook.component.svg";
import linkedinIcon from "@svg-icons/linkedin.component.svg";
import youtubeIcon from "@svg-icons/youtube.component.svg";
import instagramIcon from "@svg-icons/instagram.component.svg";
import XIcon from "@svg-icons/x_logo.component.svg";
import classnames from "classnames";
import { Heading } from "@components/Heading/Heading";

interface StaticticsItem {
  BottomText: string;
  TopText: string;
  key: string;
}
interface LinkListeGroup {
  Headline: string;
  Links: LinkListeGroupItem[];
}
interface LinkListeGroupItem {
  Name: string;
  Url: string;
  Target: string;
}
export interface FooterProps {
  statictics: StaticticsItem[];
  linkListe: LinkListeGroup[];
  address: string;
}

const Footer: React.FC<FooterProps> = ({ statictics, linkListe, address }) => (
  <Box as="footer" className={styles.footer}>
    <Box className={styles.footerInforow}>
      <Container
        className={styles.footerGrid}
        {...(statictics.length < 4 && { variant: "small" })}
      >
        {statictics &&
          statictics.map((stats: StaticticsItem, index: number) => (
            <Box
              className={classnames(
                styles.footerGridColumn,
                styles.footerInforowColumn
              )}
              key={`statictics__${index}`}
            >
              <Heading as="h3">{stats.TopText}</Heading>
              <Text>{stats.BottomText}</Text>
            </Box>
          ))}
      </Container>
    </Box>
    <Container
      variant="large"
      className={classnames(
        styles.footerGrid,
        styles.footerListlist,
        styles.footerGridLeftAlign
      )}
    >
      {linkListe &&
        linkListe.map((group, index) => (
          <Box className={styles.footerGridColumn} key={`linklist__${index}`}>
            <Heading as="h3">{group.Headline}</Heading>
            <Box as="ul">
              {group.Links &&
                group.Links.map(
                  (groupItem: LinkListeGroupItem, index: number) => {
                    return (
                      <Box as="li" key={`linklist__Link_${index}`}>
                        <Link
                          href={groupItem.Url}
                          className={styles.linkItem}
                          {...(groupItem.Target && {
                            target: groupItem.Target
                          })}
                        >
                          {groupItem.Name}
                        </Link>
                      </Box>
                    );
                  }
                )}
            </Box>
          </Box>
        ))}
    </Container>
    <Container className={styles.footerBottom}>
      <Box
        className={styles.footerAddress}
        dangerouslySetInnerHTML={{ __html: address }}
      ></Box>
      <Box as="ul" className={styles.footerSocial}>
        <Box as="li">Følg Sikker Trafik</Box>
        <Box as="li">
          <Link
            href="https://www.facebook.com/sikkertrafik"
            title="Facebook"
            target="_blank"
            className="facebook"
          >
            <Icon svg={facebookIcon} />
          </Link>
        </Box>
        <Box as="li">
          <Link
            href="https://www.linkedin.com/company/raadet-for-sikker-trafik"
            title="Linkedin"
            target="_blank"
            className="linkedin"
          >
            <Icon svg={linkedinIcon} />
          </Link>
        </Box>
        <Box as="li">
          <Link
            href="https://twitter.com/sikkertrafik"
            title="X (Twitter)"
            target="_blank"
            className="x_twitter"
          >
            <Icon svg={XIcon} />
          </Link>
        </Box>
        <Box as="li">
          <Link
            href="https://www.youtube.com/user/Sikkertrafik"
            title="YouTube"
            target="_blank"
            className="youtube"
          >
            <Icon svg={youtubeIcon} />
          </Link>
        </Box>
        <Box as="li">
          <Link
            href="https://www.instagram.com/raadet_for_sikker_trafik/"
            title="Instagram"
            target="_blank"
            className="instagram"
          >
            <Icon svg={instagramIcon} />
          </Link>
        </Box>
      </Box>
    </Container>
  </Box>
);
export { Footer };
